import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { TargetNodeTreeEditorSearchSchema } from '@/features/stacktrace/products/components/TargetNodeTreeEditor/search-schema';

// Value 詳細 > 方法タブ > 対応機能（方法↔機能紐付け）の編集画面 (STK-073)。
// URL search（expandMode: 展開モードタブ / q: 名前検索）は共通エディタの
// スキーマ（TargetNodeTreeEditorSearchSchema）を利用し、コンポーネントは
// index.lazy.tsx で遅延ロードする。完了時は方法タブ（methods/index）へ戻す。
export const Route = createFileRoute('/_stacktrace/values/$id/_layout/methods/$methodId/edit-nodes/')({
  validateSearch: zodValidator(TargetNodeTreeEditorSearchSchema)
});